import React, { useEffect, useState } from 'react';
import './headerNew1.scss';
import {
    FaUser,
    FaBell,
    FaCog,
    FaSignOutAlt,
    FaArrowLeft,
    FaArrowRight,
    FaMoneyCheckAlt,
} from 'react-icons/fa';
import { LuHistory } from "react-icons/lu";
import { BiSupport } from "react-icons/bi";
import { FaAngleRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import WelcomeToDashboard from '../../../assets/images/welcomeToDashboard.jpg'
import MoneyInternational from '../../../assets/images/moneyInternational.jpg'
import StayTopTransaction from '../../../assets/images/stayTopTransaction.png'

const menuItems = [
    { icon: <FaUser />, label: 'Profile', path: "/personal-data" },
    { icon: <FaBell />, label: 'Notifications', path: "/all-notifications" },
    { icon: <FaCog />, label: 'Settings', path: "/alert-panel" },
    { icon: <FaSignOutAlt />, label: 'Logout', path: "#" },
];

const shortLinks = [
    { icon: <FaMoneyCheckAlt />, label: "Single Transfer", path: "/new-payment" },
    { icon: <LuHistory />, label: "Transactions", path: "/balance-and-movements" }
];

const cards = [
    {
        image: WelcomeToDashboard,
        title: 'Welcome to Your Dashboard',
        body: 'Your dashboard provides a quick overview of your balance, transactions, and transfers. Start managing your finances easily with all key features in one place.'
    },
    {
        image: MoneyInternational,
        title: 'Need to Send Money?',
        body: 'Use the Single Transfer feature to securely send money to any account, locally or internationally. Ensure fast and easy transfers for your financial needs.'
    },
    {
        image: StayTopTransaction,
        title: 'Stay on Top of Transactions',
        body: 'Track and manage all your transactions in one place, from deposits to transfers. Stay informed and in control of your account with real-time updates.'
    }
];

export default function DesktopRightSidebar({ showSidebar, setShowSidebar, isMobile, user, hasOverflowY }) {
    const navigate = useNavigate();
    const [showTrigger, setShowTrigger] = useState(false);
    const [currentCard, setCurrentCard] = useState(0);

    const logOut = () => {
        localStorage.removeItem("isClient");
        localStorage.removeItem("auth_client");
        navigate("/login");
    };

    useEffect(() => {
        if (!showSidebar) {
            const timeout = setTimeout(() => setShowTrigger(true), 300);
            return () => clearTimeout(timeout);
        } else {
            setShowTrigger(false);
        }
    }, [isMobile, showSidebar]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentCard((prev) => (prev + 1) % cards.length);
        }, 15000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div className={`sidebar desktop ${showSidebar ? 'open' : ''}`} >
                <div className="sidebar-header">
                    <span>Welcome</span>
                    <h5><h5>{user?.first_name} {user?.last_name}</h5></h5>
                </div>

                <div className="sidebar-menu">
                    {menuItems.map((item, idx) => (
                        item.label === 'Logout' ?
                            (
                                <div key={idx} className="sidebar-item" onClick={() => logOut()}>
                                    <span className="sidebar-icon" style={{ fontSize: "25px" }}> {item.icon}</span>
                                    <span style={{ marginTop: "4px" }}>{item.label}</span>
                                </div>

                            ) : (
                                <div key={idx} className="sidebar-item" onClick={() => navigate(item.path)}>
                                    <span className="sidebar-icon" style={{ fontSize: "25px" }}> {item.icon}</span>
                                    <span style={{ marginTop: "4px" }}>{item.label}</span>
                                </div>
                            )
                    ))}
                </div >

                {showSidebar && (
                    <>
                        <div className="sidebar-menu px-3 mt-4">
                            <h6>SHORT LINKS</h6>
                            {shortLinks.map((item, idx) => (
                                <div key={idx} className="sidebar-item" onClick={() => navigate(item.path)}>
                                    <span className="sidebar-icon" style={{ fontSize: "25px" }}>{item.icon}</span>
                                    <span style={{ marginTop: "4px" }}>{item.label}</span>
                                </div>
                            ))}
                        </div>
                        <div className="sidebar-card-slider mt-4">
                            <div className="card-carousel">
                                {cards.map((card, idx) => (
                                    <div
                                        key={idx}
                                        className={`card-slide ${idx === currentCard ? 'active' : ''}`}
                                        style={{ display: idx === currentCard ? 'block' : 'none' }}
                                    >
                                        <img src={card.image} alt={card.title} className="card-image" />
                                        <h6 className="card-title my-2">{card.title}</h6>
                                        <p className="card-body text-muted small">{card.body.slice(0, 160)}...</p>
                                    </div>
                                ))}
                            </div>

                            <div className="carousel-dots d-flex justify-content-center mt-2">
                                {cards.map((_, idx) => (
                                    <span
                                        key={idx}
                                        className={`dot ${idx === currentCard ? 'active' : ''}`}
                                        onClick={() => setCurrentCard(idx)}
                                    />
                                ))}
                            </div>
                        </div>
                    </>
                )}

                <button
                    className="sidebar-collapse"
                    onClick={() => setShowSidebar(false)}
                    aria-label="Collapse Sidebar"
                >
                    <FaArrowRight />
                </button>



                <div className="support-textabove">
                    <span>Need Help?</span>
                </div>
                <div className="sidebar-support" onClick={() => navigate('/request-appointment')}>
                    <div className="sidebar-item">
                        <span className="sidebar-icon"><BiSupport /></span>
                        <span className="support-text">Contact Support</span>
                        <span className="ml-auto"><FaAngleRight /></span>
                    </div>
                </div>

            </div >

            {!showSidebar && showTrigger && (
                <button
                    className="sidebar-trigger"
                    onClick={() => setShowSidebar(true)}
                    aria-label="Open Sidebar"
                >
                    <FaArrowLeft />
                </button>
            )}
        </>
    );
}